var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100 mx-auto text-center"},[_c('h5',{staticClass:"description"},[_vm._v(" Wellcome ")])])])
}]

export { render, staticRenderFns }